import { render } from "./mallListItem.vue?vue&type=template&id=c74a2184&scoped=true&ts=true"
import script from "./mallListItem.vue?vue&type=script&lang=ts"
export * from "./mallListItem.vue?vue&type=script&lang=ts"

import "./mallListItem.vue?vue&type=style&index=0&id=c74a2184&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74a2184"]])

export default __exports__